import { S3Client } from '@aws-sdk/client-s3';
import { Upload } from '@aws-sdk/lib-storage';

const BUCKET = import.meta.env.VITE_S3_BUCKET;
const REGION = import.meta.env.VITE_S3_REGION;
const ACCESS_KEY = import.meta.env.VITE_S3_ACCESS_KEY;
const SECRET_ACCESS_KEY = import.meta.env.VITE_S3_SECRET_KEY;

const uploadFile = (file: File, id: string, type: string) => {
  const fileName = `${id}-${type}.${file.name.split('.').pop()}`;

  // Upload file to aws s3 bucket
  new Upload({
    client: new S3Client({
      credentials: {
        accessKeyId: ACCESS_KEY,
        secretAccessKey: SECRET_ACCESS_KEY,
      },
      region: REGION,
    }),
    params: {
      Bucket: BUCKET,
      Key: fileName,
      Body: file,
    },
    tags: [], // optional tags
    queueSize: 4, // optional concurrency configuration
    partSize: 1024 * 1024 * 5, // optional size of each part, in bytes, at least 5MB
    leavePartsOnError: false, // optional manually handle dropped parts
  })
    .done()
    .then((data) => {
      // console.log(data);
    })
    .catch((err) => {
      console.log(err);
    });

  const res = {
    url: `https://${BUCKET}.s3.${REGION}.amazonaws.com/${fileName}`,
    key: fileName,
    preview: 'result.request.httpRequest.body.preview',
  };

  localStorage.setItem(type + 'Url', JSON.stringify(res.key));

  return res;
};

export default uploadFile;
